import { render, staticRenderFns } from "./MyAttestationGrade.vue?vue&type=template&id=6214e582&scoped=true&"
import script from "./MyAttestationGrade.vue?vue&type=script&lang=js&"
export * from "./MyAttestationGrade.vue?vue&type=script&lang=js&"
import style0 from "./MyAttestationGrade.vue?vue&type=style&index=0&id=6214e582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214e582",
  null
  
)

export default component.exports